import { Paper, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BrandsFilterItems from "./BrandsFilterItems";

interface BrandsFilterCardProps {
  brandOptions: string[];
  selectedBrand: string;
  onSelectedBrandChange: (brand: string) => void;
  selectedMonth: number;
  onSelectedMonthChange: (month: number) => void;
  selectedYear: number;
  onSelectedYearChange: (year: number) => void;
  disableMonthYear?: boolean;
}

export default function BrandsFilterCard({
  brandOptions,
  selectedBrand,
  onSelectedBrandChange,
  selectedMonth,
  onSelectedMonthChange,
  selectedYear,
  onSelectedYearChange,
  disableMonthYear = false,
}: BrandsFilterCardProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: "18px 22px",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 2.25,
        borderColor: "#ececec",
      }}
    >
      <BrandsFilterItems
        options={brandOptions}
        selectedBrand={selectedBrand}
        onSelectedBrandChange={onSelectedBrandChange}
        selectedMonth={selectedMonth}
        onSelectedMonthChange={onSelectedMonthChange}
        selectedYear={selectedYear}
        onSelectedYearChange={onSelectedYearChange}
        disableMonthYear={disableMonthYear}
      />
      <Stack
        direction="row"
        spacing={0.75}
        alignItems="center"
        sx={{ ml: "auto", color: "#9e9e9e" }}
      >
        <InfoOutlinedIcon fontSize="small" sx={{ color: "#8E24AA", fontSize: 16 }} />
        <Typography variant="caption" sx={{ fontSize: 13 }}>
          Month/Year applies to the Monthly and Reporting Attempt tables - powered by BQL
        </Typography>
      </Stack>
    </Paper>
  );
}
